// extracted by mini-css-extract-plugin
export default {"form":"TranslateWhoWeAreTitleAndDescriptionForm_form__6uzef","form-group":"TranslateWhoWeAreTitleAndDescriptionForm_form-group__lBfZ6"};